module.exports = __webpack_public_path__ + "img/617-42dfb3.png";